export function toMap<T, V = T, K = string>(
    objs: T[],
    indexCallback: (obj: T) => K,
    valueCallback?: (obj: T) => V
): Map<K, V> {
    const result: Map<K, V> = new Map();
    objs.forEach((obj) => {
        result.set(indexCallback(obj), (valueCallback ? valueCallback(obj) : obj) as V);
    });
    return result;
}

export function flatObjectKeys<T extends Record<string, unknown>>(
    currentNode: object,
    target?: Partial<T>,
    flattenedKey?: string
): T {
    const newTarget: Partial<T> = target ?? {};
    Object.entries(currentNode).forEach(([key, value]) => {
        const newKey = flattenedKey === undefined ? key : `${flattenedKey}.${key}`;
        if (typeof value === 'object') {
            flatObjectKeys(value, newTarget, newKey);
        } else {
            // @ts-ignore
            newTarget[newKey] = value;
        }
    });
    return newTarget as T;
}

export function toMapArray<T, V = T, K = string>(
    objs: T[],
    indexCallback: (obj: T) => K,
    valueCallback?: (obj: T) => V
): Map<K, V[]> {
    const result: Map<K, V[]> = new Map();
    objs.forEach((obj) => {
        const index = indexCallback(obj)
        const val = (valueCallback ? valueCallback(obj) : obj) as V
        if (result.has(index)) {
            (result.get(index) as V[]).push(val)
        } else {
            result.set(index, [val])
        }
    });
    return result;
}

export function toIndexObjects<T, V = T>(
    objs: T[],
    indexCallback: (obj: T) => string,
    valueCallback?: (obj: T) => V
): Record<string, V> {
    const map = toMap<T, V>(objs, indexCallback, valueCallback);
    return Object.fromEntries(map.entries());
}